export const Provinces = [
    {
        value: 'AB', label: 'Alberta'
    },
    {
        value: 'BC', label: 'British Columbia'
    },
    {
        value: 'MB', label: 'Manitoba'
    },
    {
        value: 'NB', label: 'New Brunswick'
    },
    {
        value: 'NL', label: 'Newfoundland and Labrador'
    },
    {
        value: 'NS', label: 'Nova Scotia'
    },
    {
        value: 'ON', label: 'Ontario'
    },
    {
        value: 'PE', label: 'Prince Edward Island'
    },
    {
        value: 'QC', label: 'Quebec'
    },
    {
        value: 'SK', label: 'Saskatchewan'
    },
    {
        value: 'NT', label: 'Northwest Territories'
    },
    {
        value: 'NU', label: 'Nunavut'
    },
    {value: 'YT', label: 'Yukon'},
]

